<template>
  <tr class="hovereable" @click="applyTemplate">
    <td width="70">
      <v-avatar size="45" class="transparent">
        <v-icon large class="k-orange-linear-text" v-if="item.channel_id === 2">fas fa-comment</v-icon>
        <v-icon large class="k-orange-linear-text" v-else-if="item.channel_id === 7">fab fa-whatsapp</v-icon>
        <v-icon large class="k-orange-linear-text" v-else-if="item.channel_id === 1">fas fa-envelope</v-icon>
      </v-avatar>
    </td>
    <td class="text-xs-left">
      {{ item.name }}
      <small class="d-block">
        {{ removeHtmlTags(item.text) }}
      </small>
    </td>
    <td>
      <div class="box" v-if="hasFiles">
        <div class="file-container d-flex align-center tex-truncate" v-for="(file, index) in item.files" :key="`file-item-${index}`">
          <v-icon small class="mr-2">fa fa-file</v-icon>
          <small>{{ file.original_name }}</small>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import removeHtmlTags from '@/mixins/removeHtmlTags';

export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [
    removeHtmlTags,
  ],
  computed: {
    hasFiles() {
      return (this.item.files || []).length > 0;
    },
  },
  methods: {
    applyTemplate() {
      this.$emit('selected', this.item);
      this.$emit('close');
    },
  },
};
</script>
<style scoped>
small {
  width: 300px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.box {
  position: relative;
  padding: .5em;
  border: 1px solid #CCCCCC;
  background-color: #E3E3E3;
}
.box small {
  color: #404040;
}
.hovereable:hover .box {
  border: 1px solid #fff;
  background-color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/answer_template/AnswerTemplatesListV2.vue